import React from 'react';
import type {Guest, GuestGroup} from '@chekin/core';

export type GuestFormEnv = {
  fieldAutoComplete?: 'on' | 'off';
  showRecentCountries?: boolean;
  guestGroup?: GuestGroup;
  isLeaderGuest: boolean;
  checkInDate?: string;
  policeAccountType?: string;
  isPoliceRegistrationEnabled?: boolean;
  autoSignature?: boolean;
  reservationId?: string;
  housingId?: string;
  countryCode?: string;
  guest?: Guest;
  isContractEnabled?: boolean;
  privacyPolicyUrl?: string;
};

const DEFAULT_ENV: GuestFormEnv = {
  isLeaderGuest: false,
};

const GuestFormEnvContext = React.createContext<GuestFormEnv>(DEFAULT_ENV);

function useGuestFormEnv(): GuestFormEnv {
  return React.useContext(GuestFormEnvContext);
}

export {DEFAULT_ENV, GuestFormEnvContext, useGuestFormEnv};
